// Redimensiona uma imagem no navegador antes de enviar (crop central quadrado +
// canvas). Nasceu no avatar do Perfil (PO1-1918) e foi extraído na PO1-2722 para
// o logo da transportadora: o backend_hub roda em Node 12 sem sharp/jimp, então a
// normalização fica aqui. Duas saídas: data URL (o avatar grava a string) e Blob
// (o logo vai por multipart).

function desenharQuadrado(file, maxSize) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Falha ao ler o arquivo"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Arquivo de imagem inválido"));
      img.onload = () => {
        const side = Math.min(img.width, img.height);
        const sx = (img.width - side) / 2;
        const sy = (img.height - side) / 2;
        const canvas = document.createElement("canvas");
        canvas.width = maxSize;
        canvas.height = maxSize;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, sx, sy, side, side, 0, 0, maxSize, maxSize);
        resolve(canvas);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

// PO1-3317: cabe a imagem inteira numa caixa maxW×maxH, sem cortar e sem
// distorcer (logo de transportadora costuma ser horizontal). Só reduz: imagem
// menor que a caixa mantém o tamanho. Nenhum lado fica abaixo de `minLado`
// (o backend recusa < 32 px).
export function calcularTamanhoContido(largura, altura, maxW, maxH, minLado = 32) {
  const escala = Math.min(1, maxW / largura, maxH / altura);
  let w = Math.round(largura * escala);
  let h = Math.round(altura * escala);
  if (w < minLado || h < minLado) {
    const sobe = minLado / Math.min(w, h);
    w = Math.round(w * sobe);
    h = Math.round(h * sobe);
  }
  return { largura: w, altura: h };
}

function desenharContido(file, maxW, maxH) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Falha ao ler o arquivo"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Arquivo de imagem inválido"));
      img.onload = () => {
        const { largura, altura } = calcularTamanhoContido(img.width, img.height, maxW, maxH);
        const canvas = document.createElement("canvas");
        canvas.width = largura;
        canvas.height = altura;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, largura, altura);
        resolve(canvas);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export function resizeImageContainToBlob(file, maxW, maxH, { mime = "image/png", quality = 0.92 } = {}) {
  return desenharContido(file, maxW, maxH).then(
    (canvas) =>
      new Promise((resolve, reject) => {
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("Falha ao gerar a imagem"))), mime, quality);
      })
  );
}

export function resizeImageToDataUrl(file, maxSize = 256, { mime = "image/jpeg", quality = 0.85 } = {}) {
  return desenharQuadrado(file, maxSize).then((canvas) => canvas.toDataURL(mime, quality));
}

// PNG por padrão: preserva a transparência do logo (o fundo branco é do
// contêiner, não do arquivo).
export function resizeImageToBlob(file, maxSize = 256, { mime = "image/png", quality = 0.92 } = {}) {
  return desenharQuadrado(file, maxSize).then(
    (canvas) =>
      new Promise((resolve, reject) => {
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("Falha ao gerar a imagem"))), mime, quality);
      })
  );
}
